module.exports = __webpack_public_path__ + "static/p-4-c7cf6df63f2c74c182b007d7d979b489.jpg";